export default __webpack_public_path__ + "app/images/cff12a309c618a28534734500e335b9f.svg";